var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-card-title',[_vm._v("Profiel")])],1),_c('b-card-body',[(_vm.profiel)?_c('b-list-group',_vm._l((_vm.profiel.auth),function(value,key){return _c('b-list-group-item',{key:key},[_vm._v("\n        "+_vm._s(key)+" : "+_vm._s(value)+"\n      ")])}),1):_vm._e()],1),_c('b-card-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }